import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';
import Modal from '@lwt-helix/modal';
import { Button } from '@lwt-helix/buttons';
import { removeUserFromClient } from '../../../../api/AuthenticationApi';
import RemoveUserNotification from './Notifications';
import { removingUserReset } from '../../../../actions/AuthActions';

const RemoveUserModal = ({
     show,
     closeModal,
     userId,
     clientId,
     error,
     response,
     onRemove
 }) => {
    const [apiStatus, setApiStatus] = useState('init');
    const dispatch = useDispatch();

    const removeUser = useCallback(() => {
        setApiStatus('pending');
        dispatch(removeUserFromClient(userId, clientId));
    }, [clientId, setApiStatus, userId]);

    const reset = () => {
        if (apiStatus === 'success') {
            onRemove();
        }
        setApiStatus('init');
        dispatch(removingUserReset());
        closeModal();
    };

    useEffect(() => {
        if (response != null) {
            setApiStatus('success');
        } else if (error != null) {
            setApiStatus('error');
        }
    }, [error, response]);

    const renderSendCancelButtons = (
        <>
            <Button
                outline={true}
                onClick={reset}
                className="mr-2"
                dataLwtId="cancel-remove-user-button"
                disabled={apiStatus === 'pending'}
            >
                Cancel
            </Button>
            <Button
                color="danger"
                onClick={removeUser}
                dataLwtId="confirm-remove-user-button"
                disabled={apiStatus === 'pending'}
            >
                Remove User
            </Button>
        </>
    );

    const renderCloseButton = (
        <Button
            outline={true}
            onClick={reset}
            dataLwtId="close-remove-user-modal-button"
        >
            Close
        </Button>
    );

    const renderModalButtons = () => {
        return apiStatus === 'success'
            ? renderCloseButton
            : renderSendCancelButtons;
    };

    const message = (
        <>
            Are you sure you would like to remove this user?<br />
            This user will not be able to use Lone Wolf applications for your brokerage.
            <br />
            <div className="float-right">{renderModalButtons()}</div>
            <br />
            <RemoveUserNotification status={apiStatus} />
        </>
    );

    return (
        <Modal
            size="lg"
            dataLwtId="remove-user-modal"
            title="Remove User"
            show={show}
            showFooter={false}
        >
            {message}
        </Modal>
    );
};

RemoveUserModal.propTypes = {
    show: PropTypes.bool,
    closeModal: PropTypes.func,
    userId: PropTypes.string,
    clientId: PropTypes.string,
    error: PropTypes.object,
    response: PropTypes.object,
    onRemove: PropTypes.func
};

export default RemoveUserModal;
